export const USER_STATUS_APPEARANCE = {
  ACTIVE: {color: 'green'},
  UNVERIFIED: {color: 'orange'},
  LOCK: {color: 'red'},
  DELETED: {color: '#f50'},
};

export const INVITE_USER_STATUS_APPEARANCE = {
  ACCEPTED: {color: 'green'},
  PENDING: {color: '#4692c4'},
};

export const USER_TYPE_APPEARANCE = {
  USER: {color: 'green'},
  HISTORIAN: {color: 'orange'},
  FUNCTIONARY: {color: 'red'},
  NOTARY: {color: 'blue'},
  ONAT_USER: {color: '#e50d0c'},
  NOTARY_DPJ: {color: 'grey'},
  COMMERCIAL_REGISTER: {color: 'olive'},
  FUNCTIONARY_ORGANIZATION: { color: 'green' },
};

export const USER_STATUS = {
  ACTIVE: 'ACTIVE',
  UNVERIFIED: 'UNVERIFIED',
  LOCK: 'LOCK',
  DELETED: 'DELETED',
};
